module.exports = __webpack_public_path__ + "img/logo-im.44124872.svg";